<template>
  <div>
    <div class="intro-y flex flex-col sm:flex-row items-center mt-8">
      <h2 class="text-lg font-medium mr-auto">
        รายละเอียด Memo - {{ formMemo.docNoFull }}
      </h2>
      <div class="w-full sm:w-auto flex mt-4 sm:mt-0" v-if="!loading">
        <router-link
          type="button"
          :to="{ name: 'memoDocAll' }"
          class="btn box text-gray-700 mr-2 flex items-center ml-auto sm:ml-0"
        >
          <ArrowLeftIcon class="w-4 h-4 mr-2" /> Back
        </router-link>
        <!-- <button
          type="button"
          class="btn box text-gray-700 mr-2 flex items-center ml-auto sm:ml-0"
        >
          <EyeIcon class="w-4 h-4 mr-2" /> Preview
        </button> -->
        <!-- <button
          type="button"
          class="btn btn-danger disabled:opacity-50 mr-2 flex items-center ml-auto sm:ml-0"
          @click.prevent="cancelMemo"
          :disabled="btnCancel.disabled"
          v-show="!btnCancel.hide"
        >
          <XCircleIcon class="w-4 h-4 mr-2" v-if="!btnCancel.loading" />
          <LoadingIcon icon="oval" color="white" v-else class="w-4 h-4 mr-2" />
          ยกเลิกเอกสาร
        </button> -->

        <a
          href="javascript:;"
          class="btn btn-danger disabled:opacity-50 flex items-center"
          data-toggle="modal"
          data-target="#cancel-modal-preview"
          :disabled="btnCancel.disabled"
          v-show="!btnCancel.hide"
        >
          <XCircleIcon
            class="w-4 h-4 mr-2 hidden md:block"
            v-if="!btnCancel.loading"
          />
          <LoadingIcon icon="oval" color="white" v-else class="w-4 h-4 mr-2" />
          ยกเลิกเอกสาร
        </a>
        <!-- <button
          type="button"
          class="btn btn-primary disabled:opacity-50 mr-2 flex items-center ml-auto sm:ml-0"
          @click.prevent="approve()"
          :disabled="isApprove"
          v-show="isHideApprove"
        >
          <FileTextIcon class="w-4 h-4 mr-2" v-if="!isApprove" />
          <LoadingIcon icon="oval" color="white" v-else class="w-4 h-4 mr-2" />
          บันทึกอนุมัติ
        </button> -->
        <!-- <button
          v-if="formDataApprove.approve_date"
          type="button"
          class="btn box disabled:opacity-50 mr-2 flex items-center ml-auto sm:ml-0  border-2 border-theme-9 text-theme-9"
        >
          <CheckCircleIcon class="w-4 h-4 mr-2" /> บันทึกอนุมัติ
          {{ formDataApprove.approve_date }}
        </button> -->
        <a
          v-show="btnResendShow"
          href="javascript:;"
          class="btn box disabled:opacity-50 mr-2 flex items-center ml-auto sm:ml-0  border-2"
          data-toggle="modal"
          data-target="#resend-mail-modal-confirm"
        >
          <SendIcon class="w-4 h-4 mr-2" v-if="!mailSending" />
          <LoadingIcon icon="oval" color="orange" v-else class="w-4 h-4 mr-2" />
          Send Mail
        </a>
        <BtnPrinter module="memo" :doc-id="formMemo.memoID" />
        <a
          href="javascript:;"
          class="btn btn-danger ml-2 disabled:opacity-50 flex items-center"
          disabled
          v-show="formMemo.status_code == 'cancel'"
        >
          เอกสารถูกยกเลิก
        </a>
        <button
          type="button"
          class="btn btn-primary disabled:opacity-50 mr-2 flex items-center ml-auto sm:ml-2"
          @click.prevent="saveShare"
          :disabled="btnShare"
          v-if="formMemo.status_code == 'approve' && isOwner"
        >
          <Share2Icon class="w-4 h-4 mr-2" v-if="!btnShare" />
          <LoadingIcon icon="oval" color="white" v-else class="w-4 h-4 mr-2" />
          Share
        </button>
      </div>
    </div>
    <div class="grid grid-cols-12 gap-6 mt-5">
      <div class="intro-y col-span-12">
        <div class="mt-5">
          <div class="h-10 w-full text-center my-20" v-if="loading">
            <LoadingIcon icon="oval" class="w-12 h-12" />
          </div>
          <div class="horizontal-form" v-else>
            <div class="grid grid-cols-1" v-if="!loadApprove">
              <div
                class="intro-y p-5 box grid grid-cols-1 lg:grid-cols-3 xl:grid-cols-4 gap-4"
              >
                <MemoCard card-type="to" :items="formMemo.to_array" />
                <MemoCard card-type="cc" :items="formMemo.cc_array" />
              </div>
              <div
                class="intro-y p-5 mt-5 box"
                v-if="
                  isHideApprove &&
                    formMemo.status_code != 'disapprove' &&
                    formMemo.flag_edit != 2
                "
              >
                <div class="horizontal-form">
                  <div class="">
                    <label for="" class="form-label sm:w-20 font-bold"
                      >หมายเหตุ</label
                    >
                    <textarea
                      name=""
                      id=""
                      rows="5"
                      placeholder="เพิ่มเติม..."
                      class="form-control"
                      :class="{ 'border-theme-6': validateMemo.comment.$error }"
                      v-model="validateMemo.comment.$model"
                    ></textarea>
                  </div>
                  <div class="flex mt-4 flex-col md:flex-row">
                    <label for="" class="form-label mt-2 sm:w-28 font-bold"
                      >ระบุการตัดสินใจ
                    </label>
                    <div class="flex flex-row">
                      <div
                        class="form-check mr-4"
                        v-for="item in optionApprove"
                        :key="item.value"
                      >
                        <input
                          type="radio"
                          :id="`radio-${item.value}`"
                          class="form-radio-input"
                          :value="item.value"
                          v-model="formDataApprove.approve_status"
                        />
                        <label
                          :for="`radio-${item.value}`"
                          class="form-check-label"
                          >{{ item.label }}</label
                        >
                      </div>
                    </div>
                    <div
                      class="w-full sm:w-auto flex mt-4 pt-4 md:pt-0 md:ml-8 sm:mt-0"
                      v-if="!loading"
                    >
                      <button
                        type="button"
                        class="btn btn-primary disabled:opacity-50 mr-2 flex items-center ml-auto sm:ml-0"
                        @click.prevent="approve()"
                        :disabled="isApprove"
                        v-show="isHideApprove"
                      >
                        <FileTextIcon class="w-4 h-4 mr-2" v-if="!isApprove" />
                        <LoadingIcon
                          icon="oval"
                          color="white"
                          v-else
                          class="w-4 h-4 mr-2"
                        />
                        Save
                      </button>
                      <button
                        v-if="formDataApprove.approve_date"
                        type="button"
                        class="btn box disabled:opacity-50 mr-2 flex items-center ml-auto sm:ml-0 border-2 border-theme-9 text-theme-9"
                      >
                        <CheckCircleIcon class="w-4 h-4 mr-2" /> Save
                        {{ formDataApprove.approve_date }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="intro-y p-5 mt-5 box"
                v-if="formMemo.status_code == 'disapprove'"
              >
                <div class="text-theme-6 text-lg font-bold">
                  เอกสารนี้ไม่ผ่านการอนุมัติ
                </div>
              </div>
              <div class="intro-y p-5 mt-5 box" v-if="formMemo.flag_edit == 2">
                <div class="text-theme-6 text-lg font-bold">
                  เอกสารถูกตีกลับ
                </div>
                <span>หมายเหตุ: {{ formMemo.flag_edit_reason }}</span>
              </div>
            </div>

            <div class="grid grid-cols-1 md:grid-cols-2 md:space-x-4 mt-5">
              <div class="intro-y box p-5 space-y-3">
                <div class="form-inline">
                  <label for="" class="form-label sm:w-20 font-bold"
                    >วันที่</label
                  >
                  <div>{{ formMemo.docDate }}</div>
                </div>
                <div class="form-inline">
                  <label for="" class="form-label sm:w-20 font-bold"
                    >เรื่อง</label
                  >
                  <div>{{ formMemo.title }}</div>
                </div>
                <div class="form-inline">
                  <label for="" class="form-label sm:w-20 font-bold"
                    >หัวบริษัท</label
                  >
                  <div>
                    {{ formMemo.company ? formMemo.company.comp_name_th : '' }}
                  </div>
                </div>
                <div class="form-inline">
                  <label for="" class="form-label sm:w-20 font-bold"
                    >ผู้สร้าง</label
                  >
                  <div>
                    {{ formMemo.doc_owner }}
                  </div>
                </div>
              </div>

              <div class="intro-y box p-5 space-y-3 mt-5 md:mt-0 ">
                <div class="form-inline">
                  <label for="" class="form-label sm:w-20 font-bold"
                    >เรียน</label
                  >
                  <div>{{ joinToString(formMemo.to, ', ') }}</div>
                </div>
                <div class="form-inline">
                  <label for="" class="form-label sm:w-20 font-bold"
                    >ผ่าน</label
                  >
                  <div>{{ joinToString(formMemo.tocc, ', ') }}</div>
                </div>
                <div class="form-inline">
                  <label for="" class="form-label sm:w-20 font-bold"
                    >สำเนา</label
                  >
                  <div>{{ joinToString(formMemo.bcc, ', ') }}</div>
                </div>
                <div class="form-inline flex items-start">
                  <label for="" class="form-label sm:w-20 font-bold"
                    >เสนอเพื่อ</label
                  >
                  <div>{{ formMemo.objective_name }}</div>
                </div>
                <div
                  class="form-inline"
                  v-if="formMemo.status_code == 'approve' && isOwner"
                >
                  <label
                    for="wfselect-share"
                    class="form-label sm:w-20 font-bold"
                    >Share</label
                  >
                  <div class="preview w-full">
                    <WfSelect
                      key="wfselect-share"
                      v-model="validateShare.shareSelected.$model"
                      :class="
                        validateShare.shareSelected.$error
                          ? 'rounded border border-theme-6'
                          : ''
                      "
                      :options="{
                        search: true,
                        multiple: true,
                        multipleLimit: 15,
                        searchMinLength: 3,
                        items: optionEmployee,
                        labelBy: 'fullname_th',
                        valueBy: 'employee_id'
                      }"
                    ></WfSelect>
                  </div>
                </div>
              </div>
            </div>
            <div class="grid grid-cols-1 xl:grid-cols-4 xl:space-x-4">
              <div
                class="intro-y p-5 box col-span-3 mt-5 overflow-x-auto"
                style="z-index: 0;"
              >
                <div class="mb-4 text-lg font-bold">เนื้อหา</div>
                <div class="overflow-x-auto" v-html="formMemo.detail"></div>
              </div>
              <div
                class="intro-y p-5 box mt-5"
                style="z-index: 0;"
                v-if="formMemo.attach_file_array.length"
              >
                <div class="mt-4">
                  <label class="form-label font-bold">ไฟล์แนบ</label>
                  <AttachFilePreview :data="formMemo.attach_file_array" />
                </div>
              </div>
            </div>
            <div class="mt-5">
              <TableHistory :items="formMemo.history_array" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- BEGIN: Modal Content -->
    <div
      id="resend-mail-modal-confirm"
      class="modal"
      tabindex="-1"
      data-backdrop="static"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body p-0">
            <div class="p-5 text-center">
              <InfoIcon class="w-16 h-16 text-theme-12 mx-auto mt-3" />
              <div class="text-3xl mt-5">คุณแน่ใจ</div>
              <div class="text-gray-600 mt-2">
                ต้องการส่งเมลซ้ำรายการนี้ ใช่ หรือ ไม่?
              </div>
            </div>
            <div class="px-5 pb-8 text-center">
              <button
                type="button"
                data-dismiss="modal"
                class="btn btn-outline-secondary w-24 dark:border-dark-5 dark:text-gray-300 mr-1"
              >
                ไม่
              </button>
              <button
                type="button"
                data-dismiss="modal"
                class="btn btn-warning w-24"
                @click="confirmResend()"
              >
                ใช่
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- END: Modal Content -->
  </div>
  <!-- BEGIN: Modal Content -->
  <ModalCancel
    module="memo"
    doc-type="memo"
    :doc-id="formMemo.memoID"
    redirect-complete="memoDocAll"
  />
  <!-- END: Modal Content -->
</template>

<script>
import {
  defineComponent,
  computed,
  ref,
  toRefs,
  reactive,
  onMounted,
  onUnmounted
} from 'vue'
import { useStore } from '@/store'
import { useRoute } from 'vue-router'
import BtnPrinter from '@/components/BtnPrinter.vue'
import MemoCard from '@/components/MemoCard.vue'
import AttachFilePreview from '@/components/attach-file/Preview.vue'
import { api } from '@/utils/api'
import alert from '@/helpers/alert'
import ModalCancel from '@/components/ModalCancel.vue'
import WfSelect from '../../../components/select/Main.vue'
import TableHistory from '../../../components/TableHistory.vue'
import { required, requiredIf } from '@vuelidate/validators'
import { useVuelidate } from '@vuelidate/core'
export default defineComponent({
  components: {
    BtnPrinter,
    AttachFilePreview,
    MemoCard,
    ModalCancel,
    WfSelect,
    TableHistory
  },
  setup() {
    const store = useStore()
    const route = useRoute()

    const btnCancel = computed(() => store.state.memo.btnCancel)
    const loading = computed(() => store.state.global.loadingPage)
    const optionEmployee = computed(() => store.state.global.employeeAll)
    const btnShare = ref(false)

    store.dispatch('memo/loadOptionApprove')
    const optionApprove = computed(() => store.state.memo.approveStatus)

    const getOptionApproveName = val => {
      return store.getters['memo/getApproveName'](val)
    }

    const isApprove = ref(false)
    const isHideApprove = ref(false)
    const btnResendShow = ref(false)
    const isOwner = ref(false)

    const mailSending = ref(false)
    const confirmResend = async () => {
      mailSending.value = true

      await api
        // .get(`/memo/memo/reBroadcast/${formMemo.memoID}`)
        .post(
          `${process.env.VUE_APP_API_BROADCAST}/notification/sendMemoEmail`,
          { doc_id: formMemo.memoID }
        )
        .then(res => {
          if (res.code == 200) {
            alert.success(res.data.message)
          } else {
            alert.error(res.message)
          }
          mailSending.value = false
        })
        .catch(e => {
          alert.error(e.message)
          mailSending.value = false
        })
    }

    const loadApprove = ref(false)
    onUnmounted(() => {
      store.commit('global/setLoadingPage', true)
      store.commit('memo/initBtn')
    })

    const formDataApprove = reactive({
      doc_no: '',
      doc_id: '',
      employee_id: '',
      username: '',
      approve_by: '',
      comment: '',
      approve_date: '',
      approve_status: null
    })

    const formMemo = reactive({
      memoID: route.params.id || 0,
      docNoFull: '',
      docDate: '',
      title: '',
      comp_no: store.state.auth.info.comp_no,
      detail: '',
      company: '',
      objective_name: '',
      to: [],
      tocc: [],
      bcc: [],
      shareSelected: [],
      status_code: null,
      cc_array: [],
      to_array: [],
      attach_file_array: [],
      doc_owner: null,
      flag_edit: 0,
      flag_edit_reason: null,
      history_array: []
    })

    const cancelMemo = async () => {
      await store.commit('memo/setBtnActive', { type: 'btnCancel' })
      await store.dispatch('memo/cancelMemo', formMemo.memoID)
    }

    const joinToString = (data, format) => {
      return data.length ? data.join(format) : ''
    }

    const getMemo = async () => {
      if (route.params.id) {
        await api
          .get(`/memo/memo/getById/${route.params.id}`)
          .then(res => {
            if (res.code == 200) {
              formMemo.docNoFull = res.data.doc_no_full
              formMemo.title = res.data.title
              formMemo.detail = res.data.detail ? res.data.detail : ''
              formMemo.to = res.data.to_array.map(to => to.name)
              formMemo.tocc = res.data.cc_array.map(cc => cc.name)
              formMemo.bcc = res.data.bcc_array.map(bcc => bcc.name)
              formMemo.objective_name = res.data.objective_name
              formMemo.docDate = res.data.doc_date_text
                ? res.data.doc_date.split(' ')[0]
                : ''
              formMemo.to_array = res.data.to_array
              formMemo.cc_array = res.data.cc_array
              formMemo.comp_no = res.data.comp_no
              formMemo.company = store.getters['global/companyFind'](
                res.data.comp_no
              )
              formMemo.status_code = res.data.status_code
              formMemo.memoID = res.data.id
              formMemo.attach_file_array = res.data.attach_file_array
              formMemo.doc_owner = res.data.doc_owner.name
              formMemo.flag_edit = res.data.flag_edit
              formMemo.flag_edit_reason = res.data.flag_edit_reason
              formMemo.history_array = res.data.history_array

              // for approve start
              formDataApprove.doc_no = res.data.doc_no
              formDataApprove.doc_id = res.data.id
              formDataApprove.employee_id = store.state.auth.info.employeeId
              formDataApprove.username = store.state.auth.info.username
              formDataApprove.approve_by = 'normal'
              formDataApprove.comment = res.data.approver_info.comment
              formDataApprove.approve_date = res.data.approver_info.approve_date
              formDataApprove.approve_status =
                res.data.approver_info.approve_status
              // for approve end

              isOwner.value =
                res.data.doc_owner.employee_id ==
                store.state.auth.info.employeeId

              btnResendShow.value =
                res.data.doc_owner.employee_id ==
                  store.state.auth.info.employeeId &&
                res.data.status_code == 'wait'

              isHideApprove.value =
                res.data.approver_info.approve_status === null &&
                res.data.approver_info.employee_id ===
                  store.state.auth.info.employeeId
              if (
                res.data.status_code == 'wait' &&
                res.data.doc_owner.employee_id ==
                  store.state.auth.info.employeeId
              ) {
                store.commit('memo/setBtn', {
                  type: 'btnCancel',
                  value: 'hide'
                })
              }
            } else {
              alert.error(res.message)
            }
          })
          .catch(e => {
            alert.error(e.message)
          })
      }
    }

    const rulesMemo = {
      comment: {
        required: requiredIf(() => formDataApprove.approve_status !== 'approve')
      }
    }
    const validateMemo = useVuelidate(rulesMemo, toRefs(formDataApprove))

    const approve = async () => {
      isApprove.value = true
      validateMemo.value.$touch()
      if (validateMemo.value.$invalid) {
        isApprove.value = false
        return false
      }
      validateMemo.value.$reset()
      await api
        .post('/memo/memo/approve', formDataApprove)
        .then(res => {
          if (res.code == 200) {
            getMemo()
            alert.success()
          } else {
            alert.error(res.message)
          }
          isApprove.value = false
        })
        .catch(e => {
          alert.error(e.message)
          isApprove.value = false
        })
    }

    const rulesShare = {
      shareSelected: { required }
    }
    const validateShare = useVuelidate(rulesShare, toRefs(formMemo))

    const saveShare = async () => {
      validateShare.value.$touch()
      if (!validateShare.value.$invalid) {
        btnShare.value = true
        await api
          .post('/memo/memo/share', {
            id: formMemo.memoID,
            bcc: formMemo.shareSelected
          })
          .then(res => {
            if (res.code == 200) {
              formMemo.shareSelected = []
              getMemo()
              alert.success()
            } else {
              alert.error(res.message)
            }
            btnShare.value = false
            validateShare.value.$reset()
          })
          .catch(e => {
            alert.error(e.message)
            btnShare.value = false
          })
      }
    }

    onMounted(async () => {
      store.dispatch('global/loadCompany')
      store.dispatch('global/loadEmployeeAll')
      await getMemo()
      await store.commit('global/setLoadingPage', false)
    })

    return {
      loadApprove,
      btnCancel,
      approve,
      cancelMemo,
      loading,
      formDataApprove,
      isApprove,
      optionApprove,
      isHideApprove,
      getOptionApproveName,
      mailSending,
      confirmResend,
      btnResendShow,
      formMemo,
      joinToString,
      optionEmployee,
      btnShare,
      saveShare,
      validateMemo,
      isOwner,
      validateShare
    }
  }
})
</script>
